module.exports = __webpack_public_path__ + "img/login_bg.18c75af5.png";